import { info } from './getAdvertiser'
import { list } from './list'

export default {
  ...list,
  ...info
}
